export default function HomePage() {
  return (
    <main>
      {/* Hero Section */}
      <section className="relative w-full h-[480px] md:h-[620px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20illustration%20collage%20with%20warm%20amber%20and%20golden%20tones%2C%20artistic%20comic%20panel%20aesthetic%2C%20abstract%20ink%20wash%20background%2C%20dramatic%20lighting%2C%20modern%20Korean%20digital%20art%20style%2C%20rich%20textures%2C%20cinematic%20composition&width=1600&height=900&seq=home-hero-2026&orientation=landscape"
          alt="虚空韩漫网 - 韩漫在线免费看"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        <div className="relative z-10 w-full px-4 md:px-6 max-w-[1440px] mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 font-heading tracking-tight">
            韩漫在线免费看
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            虚空韩漫网提供独特的韩漫在线免费看体验，韩漫免费漫画在线观看采用下拉式免费阅读，带给您新颖的阅读感受。
          </p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <a
              href="/category/all"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line text-base w-4 h-4 flex items-center justify-center"></i>
              开始阅读
            </a>
            <a
              href="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 text-white rounded-full text-sm font-semibold hover:bg-white/25 transition-colors backdrop-blur-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line text-base w-4 h-4 flex items-center justify-center"></i>
              了解更多
            </a>
          </div>
          <div className="mt-10 flex items-center justify-center gap-8 flex-wrap">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">12,000+</p>
              <p className="text-xs md:text-sm text-white/70 mt-1">收录漫画</p>
            </div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">580万+</p>
              <p className="text-xs md:text-sm text-white/70 mt-1">累计用户</p>
            </div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">200+</p>
              <p className="text-xs md:text-sm text-white/70 mt-1">日更新话</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}